"use client"

import { productsType } from "@/interFace/general";
import { isClassroomPlanId } from "@/lib/classroomPlans";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
interface CartState {
  cartProducts: productsType[];
}

const initialState: CartState = {
  cartProducts: [],
};

const MAXQUANTITY = 10;
const ERROR_TOAST_AUTO_CLOSE_MS = 4000;

export const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    cart_product: (state, { payload }: PayloadAction<productsType>) => {
      if (payload.isPurchasable === false) {
        toast.error(payload.unavailableReason || "This plan is currently unavailable.", {
          progress: undefined,
          autoClose: ERROR_TOAST_AUTO_CLOSE_MS,
        });
        return;
      }

      const isIncomingClassroomPlan = isClassroomPlanId(payload.id);
      const productIndex = state.cartProducts.findIndex(
        (item) => item.id === payload.id
      );

      if (isIncomingClassroomPlan) {
        const existingClassroomPlan = state.cartProducts.find((item) => isClassroomPlanId(item.id));

        if (existingClassroomPlan) {
          const message = existingClassroomPlan.id === payload.id
            ? "Classroom plans can only be added once."
            : "Only one classroom plan can be purchased at a time.";

          toast.error(message, {
            progress: undefined,
            autoClose: ERROR_TOAST_AUTO_CLOSE_MS,
          });
          return;
        }
      }

      if (productIndex >= 0 && (state.cartProducts[productIndex].quantity ?? 0) < MAXQUANTITY) {
        state.cartProducts[productIndex].quantity! += 1;
        toast.success("Increase Product Quantity", { progress: undefined });
      } else if ((state.cartProducts[productIndex]?.quantity ?? 0) == MAXQUANTITY) {
        toast.error(`Maximum quantity of ${MAXQUANTITY} reached`, {
          progress: undefined,
          autoClose: ERROR_TOAST_AUTO_CLOSE_MS,
        });
      } else {
        const tempProduct = { ...payload, quantity: 1 };
        state.cartProducts.push(tempProduct);
        toast.success(`${payload.title} added to cart`, {
          progress: undefined,
          autoClose: 1000,
        });
      }
    },
    remove_cart_product: (state, { payload }: PayloadAction<productsType>) => {
      state.cartProducts = state.cartProducts.filter(
        (item) => item.id !== payload.id
      );

      toast.error(`Remove from your cart`, {
        progress: undefined,
        autoClose: ERROR_TOAST_AUTO_CLOSE_MS,
      });
    },

    clear_cart: (state) => {
      // const confirmMsg = window.confirm(
      //   "Are you sure deleted your all cart items ?"
      // );
      // if (confirmMsg) {
      //   state.cartProducts = [];
      // }
      state.cartProducts = [];
    },

    decrease_quantity: (state, { payload }: PayloadAction<productsType>) => {
      const cartIndex = state.cartProducts.findIndex(
        (item) => item.id === payload.id
      );
      if (cartIndex >= 0) {
        const totalCart = state.cartProducts[cartIndex].quantity ?? 0;
        if (totalCart > 1) {
          state.cartProducts[cartIndex].quantity = totalCart - 1;

          toast.error(`Decrease cart quantity`, {
            progress: undefined,
            autoClose: ERROR_TOAST_AUTO_CLOSE_MS,
          });
        }
        else {
          //toast.error(`Quantity cannot be less than 1`);
          // the we remove the item from the cart if equal to 0
          state.cartProducts.splice(cartIndex, 1);
        }
      }
    },
  },
});

export const {
  cart_product,
  remove_cart_product,
  clear_cart,
  decrease_quantity,
} = cartSlice.actions;

export default cartSlice.reducer;
